// Gestores (7-oct-2026). «Propietario y liquidación» (components/Gestores/OwnerSettlementPanel.vue
// y su modal OwnerFormModal.vue): la tarjeta del anuncio donde el gestor dice para quién lo lleva,
// quién cobra y cómo se le liquida.
// Árabe (RTL): los importes llegan ya aislados desde el componente. Los plurales van en UNA forma
// que vale para cualquier número («عددها {n}»): el árabe tiene seis y vue-i18n reparte dos.
export const ownerSettlement = {
  head: {
    title: "المالك والتسوية",
    sub: "إذا كنت تدير مكان الإقامة هذا لصالح مالك آخر، فحدّد من يتسلّم المدفوعات وعمولتك وطريقة التسوية معه. وعلى هذا الأساس تُحتسب تسوياته وتحليلات المدير.",
  },
  loading: "جارٍ تحميل الإعدادات…",
  loadError: {
    title: "تعذّر تحميل الإعدادات",
    text: "تحقّق من الاتصال وحاول مرة أخرى.",
    retry: "إعادة المحاولة",
  },
  master: {
    label: "أدير مكان الإقامة هذا لصالح مالك",
    hintOff: "مكان الإقامة ملكك: تُحتسب حجوزاته إيرادات خاصة بك.",
    hintOn: "تُسوّى حجوزاته مع المالك وفق الشروط أدناه.",
    kept: "تبقى الشروط التي ضبطتها محفوظة في حال أعدت التفعيل.",
    introTitle: "عند التفعيل:",
    intro1: "تختار المالك ومن يتسلّم مدفوعات الحجوزات.",
    intro2: "تحدّد عمولتك وضريبتها ومن يحتفظ بالتنظيف.",
    intro3: "ترى فوراً كيف تبدو تسويته.",
  },
  owner: {
    title: "المالك",
    hint: "الشخص أو الشركة التي تُجري معها تسوية مكان الإقامة هذا.",
    placeholder: "اختر مالكاً",
    new: "مالك جديد",
    add: "إضافة مالك",
    edit: "تعديل",
    emptyTitle: "لا يوجد لديك ملّاك بعد",
    emptyText: "أضف مالك مكان الإقامة هذا لتتمكّن من إجراء التسوية معه.",
    missing: "دون مالك محدّد، لن يكون لتسوية مكان الإقامة هذا مستفيد.",
    pending: "يُسنَد عند الحفظ",
    taxId: "الرقم الضريبي",
    addTaxId: "إضافة الرقم الضريبي",
    iban: "IBAN",
    addIban: "إضافة IBAN",
  },
  ownerForm: {
    titleNew: "مالك جديد",
    titleEdit: "تعديل المالك",
    sub: "تظهر بياناته في تسويات أماكن الإقامة التي تديرها له.",
    close: "إغلاق",
    name: "الاسم أو الاسم التجاري",
    taxId: "الرقم الضريبي",
    taxIdHint: "رقم التعريف الضريبي، من أي بلد.",
    taxIdDoubt: "إذا كان رقماً ضريبياً إسبانياً (NIF)، فحرف التحقق غير مطابق. وإذا كان من بلد آخر، فتجاهل هذا التنبيه.",
    email: "البريد الإلكتروني",
    phone: "الهاتف",
    iban: "IBAN",
    ibanPlaceholder: "SA00 0000 0000 0000 0000 0000",
    ibanHint: "الحساب الذي تحوّل إليه حصّته.",
    ibanOk: "IBAN صالح · {country}",
    address: "العنوان",
    notes: "ملاحظات",
    notesPlaceholder: "ما اتفقتما عليه، يوم الدفع…",
    sharedNote: "هو أيضاً مالك لأماكن إقامة أخرى عددها {n}: ستظهر التغييرات فيها كلها.",
    cancel: "إلغاء",
    save: "حفظ المالك",
    saving: "جارٍ الحفظ…",
    created: "تم إنشاء المالك",
    updated: "تم تحديث المالك",
    deleted: "تم حذف المالك",
    errName: "اكتب الاسم أو الاسم التجاري.",
    errEmail: "تحقّق من البريد الإلكتروني: يبدو أنه غير صالح.",
    errIbanFormat: "يبدأ IBAN برمز البلد ورقمين للتحقق (SA03…).",
    errIbanCheck: "رقما التحقق غير مطابقين: تأكّد من نسخه بشكل صحيح.",
    errIbanLength: "يتكوّن IBAN في {country} من {expected} خانة، وهذا يتكوّن من {actual}.",
    errSave: "تعذّر حفظ المالك. حاول مرة أخرى.",
    errDelete: "تعذّر حذف المالك. حاول مرة أخرى.",
    delete: "حذف المالك",
    deleteTitle: "حذف {name}؟",
    deleteText: "سيُزال من قائمة الملّاك لديك. لا يمكن التراجع عن ذلك.",
    deleteConfirm: "حذف",
    deleteBlocked: "لا يمكن الحذف: هو مالك أماكن إقامة عددها {n}. أزِله منها أولاً.",
    discardTitle: "تجاهل التغييرات؟",
    discardText: "سيضيع ما كتبته عن هذا المالك.",
    discardConfirm: "تجاهل",
    discardCancel: "متابعة التعديل",
  },
  units: {
    title: "مالك كل وحدة",
    hint: "إذا كانت إحدى الوحدات ملكاً لشخص آخر، فاختره هنا. أما باقي الوحدات فتُسوّى مع مالك الإعلان.",
    inherit: "مالك الإعلان",
    summaryNone: "كلها ملك لمالك الإعلان",
    summarySome: "وحدات لها مالك آخر: {n}",
  },
  collection: {
    title: "من يتسلّم مدفوعات الحجوزات؟",
    hint: "يغيّر هذا وجهة المال، لا ما يتبقّى للمالك.",
    ownerLabel: "يتسلّمها المالك",
    ownerDesc: "تدفع المنصات وموقعك الإلكتروني للمالك، ثم يدفع لك فاتورة أتعابك (والتنظيف إن كان من حقك).",
    managerLabel: "يتسلّمها المدير",
    managerDesc: "تصلك أموال الحجوزات، فتحتفظ بحصّتك وتحوّل إليه حصّته.",
    flowBooking: "الحجز",
    flowOwner: "المالك",
    flowYou: "أنت",
  },
  commission: {
    title: "عمولتك",
    percent: "نسبة العمولة",
    vat: "ضريبة القيمة المضافة على عمولتك",
    base: "تُحتسب على",
    presetTotal: "إجمالي الحجز",
    presetAccommodation: "الإقامة دون التنظيف",
    presetNet: "الصافي بعد عمولة منصة الحجز",
    presetDescNet: "{concepts}، دون حصّتها من عمولة منصة الحجز",
    presetNetClean: "Net of OTA and cleaning",
    presetDescNetClean: "What the owner keeps before your fee: the total minus the OTA, its VAT and cleaning",
    exampleBase: "الأساس في المثال",
    custom: "مخصّص",
    customize: "ضبط يدوي",
    baseLabel: "على أي مبلغ",
    gross: "ما يدفعه النزيل",
    net: "ما يتبقّى بعد عمولة منصة الحجز",
    netClean: "What's left after the OTA and cleaning",
    concepts: "البنود المحتسبة",
    warnTaxes: "الرسوم والضرائب ليست إيرادات: لا تُحتسب عليها عمولة عادةً.",
    fixTaxes: "استبعاد الرسوم والضرائب",
    warnCleaning: "أنت تحتسب عمولة على تنظيف تحتفظ به أصلاً.",
    fixCleaning: "استبعاد التنظيف",
    warnDeposit: "يُعاد التأمين إلى النزيل: لا تُحتسب عليه عمولة عادةً.",
    fixDeposit: "استبعاد التأمين",
    errPercent: "أدخل نسبة بين 0 و100.",
    errConcepts: "اختر بنداً واحداً على الأقل.",
  },
  concepts: {
    accommodation: "الإقامة",
    cleaning: "التنظيف",
    taxes: "الرسوم والضرائب",
    extras: "الإضافات",
    deposit: "التأمين",
  },
  // Los mismos conceptos dentro de una frase («Base: alojamiento y extras.»)
  conceptsInline: {
    accommodation: "الإقامة",
    cleaning: "التنظيف",
    taxes: "الرسوم والضرائب",
    extras: "الإضافات",
    deposit: "التأمين",
  },
  cleaning: {
    title: "التنظيف",
    hint: "من يحتفظ بما يدفعه النزيل مقابل التنظيف؟",
    owner: "من حق المالك",
    ownerDesc: "يبقى ضمن صافيه: لا يُخصم منه شيء.",
    manager: "من حقك",
    managerDesc: "تتولاه أنت ويُخصم من المالك.",
    charged: "ما يدفعه النزيل مقابل التنظيف",
    fixed: "مبلغ ثابت لكل إقامة",
    fixedAmount: "المبلغ لكل إقامة",
    fixedHint: "إذا تضمّن الحجز عدة غرف، يُحتسب المبلغ مرة واحدة لكل غرفة.",
    errAmount: "أدخل المبلغ الثابت للتنظيف لكل إقامة.",
  },
  ota: {
    title: "عمولة كل منصة حجز",
    moved: "تُضبط نسبة كل منصة حجز في بطاقة «{card}».",
    open: "فتح «{card}»",
  },
  example: {
    title: "تسوية توضيحية",
    sub: "حجز عبر {channel} بقيمة {total} وفق شروطك الحالية.",
    guest: "ما يدفعه النزيل",
    platform: "ما تحتفظ به {channel}",
    platformNote: "عمولتها: {pct}% من {base} ({concepts}).",
    platformYours: "تُعتمد نسبك في «{card}» حتى لو أرسلت {channel} عمولتها.",
    platformReal: "إذا أرسلت {channel} عمولة حجز ما، فهي التي تُستخدم.",
    platformRule: "إذا حدّدت نسبة {channel} في «{card}» فتُعتمد نسبتك، وإلا فعمولتها.",
    otaVat: "ضريبة القيمة المضافة على عمولة {channel} ({pct}%)",
    changeIn: "التغيير في «{card}»",
    changeWhere: "تُغيَّر في «{card}».",
    notOwner: "ما ليس للمالك",
    taxes: "الرسوم والضرائب",
    taxesNote: "ليست إيرادات للمالك.",
    cleaning: "التنظيف الذي تحتفظ به",
    cleaningNoteCharged: "ما يدفعه النزيل مقابله.",
    cleaningNoteFixed: "مبلغك الثابت لكل إقامة.",
    fees: "أتعاب الإدارة الخاصة بك",
    commission: "العمولة: {pct}% من {base}",
    commissionBase: "الأساس: {concepts}.",
    commissionBaseNet: "الأساس: {concepts}، دون حصّتها من عمولة {channel}.",
    commissionBaseNetClean: "Base: what the owner keeps after {channel}, its VAT and cleaning.",
    vat: "ضريبة القيمة المضافة على عمولتك ({pct}%)",
    invoice: "إجمالي فاتورة أتعابك",
    net: "الصافي للمالك",
    netNote: "ما هو من حقه في هذا الحجز.",
    netNegative: "الخصومات تتجاوز ما يتبقّى من الحجز.",
    splitTitle: "كيف يتوزّع مبلغ {total}",
    legendTaxes: "الرسوم والضرائب",
    legendCleaning: "التنظيف (لك)",
    legendFees: "أتعابك",
    legendOwner: "المالك",
    legendDeficit: "المبلغ الناقص",
    transferTitle: "تحوّل له {amount}",
    transferTitleTo: "تحوّل {amount} إلى {owner}",
    transferInvoice: "وتُصدر له فاتورة أتعابك بمبلغ {amount}.",
    owesTitle: "المالك مدين لك بمبلغ {amount}",
    owesTitleFrom: "يبقى لك على {owner} مبلغ {amount}",
    owesInvoice: "لا شيء يُحوَّل إليه. فاتورة أتعابك بمبلغ {amount}.",
    owesHint: "في هذا المثال، تتجاوز الخصومات ما يتبقّى من الحجز.",
    collectTitle: "يدفع لك المالك {amount}",
    collectTitleFrom: "تتقاضى من {owner} مبلغ {amount}",
    collectBreakdown: "هي فاتورة أتعابك ({fees}).",
    collectBreakdownCleaning: "فاتورة أتعابك ({fees}) إضافةً إلى التنظيف ({cleaning}).",
    ownerLoses: "بهذه الشروط، يخسر المالك {amount} في هذا الحجز.",
    foot: "مبالغ توضيحية. تعتمد التسوية الفعلية على تفاصيل كل حجز.",
    footNoOtaVat: "دون ضريبة القيمة المضافة على عمولة منصة الحجز.",
  },
  footer: {
    save: "حفظ التغييرات",
    saving: "جارٍ الحفظ…",
    unsaved: "تغييرات غير محفوظة",
    saved: "تم الحفظ",
    fixErrors: "راجع الحقول المحدّدة.",
    errSave: "تعذّر الحفظ. حاول مرة أخرى.",
    peekLabel: "يتبقّى للمالك",
    peekAria: "عرض التسوية التوضيحية: يتبقّى للمالك {amount}",
  },
};
